import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ExpressionCompilerService} from '@ngmedax/expression-compiler';
import {Ast} from '@ngmedax/expression-compiler';
import {WorkflowVariableDescriptor} from './types';

@Component({
  selector: 'app-workflow-conditions',
  templateUrl: './workflow-conditions.component.html',
  styleUrls: ['./workflow-conditions.component.css']
})
export class WorkflowConditionsComponent {
  @Input() variables: WorkflowVariableDescriptor[] = [];
  @Input() value: Ast.Group | null = null;
  @Output() valueChange = new EventEmitter<Ast.Group>();
  @Output() compiledChange = new EventEmitter<string>();

  public constructor(private compiler: ExpressionCompilerService) {}

  public onValueChange(group: Ast.Group) {
    this.value = group;
    this.valueChange.emit(group);
    const expr = this.compiler.compile(group);
    this.compiledChange.emit(expr);
  }
}


